import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKSelectRedirect extends TKCustomElementFactory {
    selectElement?: HTMLSelectElement;
    queryName: string;
    form?: HTMLFormElement;

    constructor() {
        super();

        this.selectElement = this.querySelector('select') || undefined;
        this.queryName = this.getAttribute('data-tk-query-name') || 'query';
        this.form = this.querySelector('form') || undefined;
    }

    connectedCallback(): void {
        if (this.form) this.registerInputListener();
        else {
            if (!this.selectElement) throw new Error('TKSelectRedirect: Select element is missing!');
            this.registerSelectListener();
        }
    }

    registerInputListener() {
        const fieldElements = this.form!.querySelectorAll('input');
        const onInputByField = this.handleInput.bind(this);
        fieldElements.forEach((fieldElements) => {
            this.pushListener({ event: 'input', element: fieldElements, action: onInputByField });
        });
    }

    registerSelectListener() {
        const onInputBySelect = this.handleSelect.bind(this);
        this.pushListener({ event: 'input', element: this.selectElement!, action: onInputBySelect });
    }

    handleSelect() {
        const selectedOption = this.selectElement?.options.item(this.selectElement.selectedIndex);
        if (!selectedOption) return;
        this.redirectByValue(selectedOption.value);
    }

    handleInput(event: KeyboardEvent) {
        const { value } = event.target as HTMLInputElement;
        this.redirectByValue(value);
    }

    redirectByValue(value: string) {
        const url = new URL(window.location.href);
        url.searchParams.set(this.queryName, value);
        window.location.href = url.href;
    }
}
